"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("reshow-runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("reshow-runtime/helpers/createClass"));
var _store = _interopRequireDefault(require("./store.js"));
//@ts-check
var StyleObject = /*#__PURE__*/function () {
  /**
   * @param {object[]} styleRules
   * @param {string|string[]|boolean} [selector]
   * @param {string|boolean} [styleId]
   */
  function StyleObject(styleRules, selector, styleId) {
    (0, _classCallCheck2["default"])(this, StyleObject);
    this.styleRules = styleRules;
    /**
     * @type {string|string[]}
     */
    this.selector = /** @type string|string[]*/selector || "";
    this.styleId = styleId;
  }

  /**
   * @returns {boolean}
   */
  (0, _createClass2["default"])(StyleObject, [{
    key: "isCompiled",
    value: function isCompiled() {
      var registry = _store["default"].registry;
      return registry && registry[/** @type {string}*/this.styleId];
    }
  }]);
  return StyleObject;
}();
var _default = exports["default"] = StyleObject;
module.exports = exports.default;